import { configureStore } from "@reduxjs/toolkit";
import { api } from "./api-client";
import accountReducer from "@/_reducers/accounts.reducer";
import reportIdReducer from "@/_reducers/reportId.reducer";

export const store = configureStore({
  reducer: {
    account: accountReducer,
    reportId: reportIdReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
